import { envAlertStatus, envAlertDescription, envAlertTitle } from '@/env'
import { CustomAlert } from '@/widgets/layout/Alert'
import { Box } from '@chakra-ui/react'

import { useState } from 'react'

export const EnvBasedAlert = () => {
  const isClosed = sessionStorage.getItem('alert') === 'false'
  const [isClosedState, setIsClosedState] = useState(isClosed)
  const handleClose = () => {
    setIsClosedState(true)
    sessionStorage.setItem('alert', 'false')
  }
  if (!envAlertTitle || !envAlertDescription || !envAlertStatus) {
    return <></>
  }

  return (
    <Box position="fixed" top={0} left={0} right={0} zIndex={1000} p={4}>
      {!isClosedState && (
        <CustomAlert
          status={envAlertStatus}
          title={envAlertTitle}
          description={envAlertDescription}
          handleClose={handleClose}
        />
      )}
    </Box>
  )
}
